import axios from './dataSources/default';
import { config } from '../config/';

export function getCashPaymentConfigDetails() {
  const uri = `${config.URLS.SOFOLOGY_API}configs/CashPaymentConfig?timestamp=${Date.now}`;
  return axios.get(uri)
    .then(res => res.data)
    .catch(() => ({ cashPaymentEnabled: false }));
}



// WEBPACK FOOTER //
// ./src/services/configService.js